const semanticClassNames = {
  root: 'selectable-container',
} as const;

export default semanticClassNames;
